"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get buildCustomMapGeometryURL () {
        return buildCustomMapGeometryURL;
    },
    get buildFullPublicWebsiteURL () {
        return buildFullPublicWebsiteURL;
    },
    get buildGuestCustomObjectURL () {
        return buildGuestCustomObjectURL;
    },
    get buildGuestDocumentUploadDetailURL () {
        return buildGuestDocumentUploadDetailURL;
    },
    get buildGuestDocumentUploadFileURL () {
        return buildGuestDocumentUploadFileURL;
    },
    get buildGuestPropertyURL () {
        return buildGuestPropertyURL;
    },
    get buildGuestWorkflowURL () {
        return buildGuestWorkflowURL;
    },
    get buildPasswordResetRequestUrl () {
        return buildPasswordResetRequestUrl;
    },
    get buildPropertyURL () {
        return buildPropertyURL;
    },
    get buildPublicUserConfirmationUrl () {
        return buildPublicUserConfirmationUrl;
    },
    get extractFirstSubdomain () {
        return extractFirstSubdomain;
    },
    get extractSubdomains () {
        return extractSubdomains;
    },
    get getAppPrefix () {
        return getAppPrefix;
    },
    get getClientAppPrefix () {
        return getClientAppPrefix;
    },
    get getPublicPortalPrefix () {
        return getPublicPortalPrefix;
    },
    get isNearmapURL () {
        return isNearmapURL;
    },
    get isRootSubdomain () {
        return isRootSubdomain;
    }
});
const _constants = require("../constants");
const _env = require("../env");
const _routing = require("../routing");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
const getPublicPortalPrefix = (subdomain)=>{
    return `${_env.APPLICATION_PROTOCOL}://${subdomain}.${_env.APPLICATION_DOMAIN}`;
};
const getClientAppPrefix = (accountSubdomain)=>{
    return `${_env.APPLICATION_PROTOCOL}://${accountSubdomain}.${_constants.INTERNAL_APP_SUBDOMAIN}.${_env.APPLICATION_DOMAIN}`;
};
const getAppPrefix = ()=>{
    return `${_env.APPLICATION_PROTOCOL}://${_constants.INTERNAL_APP_SUBDOMAIN}.${_env.APPLICATION_DOMAIN}`;
};
const buildGuestPropertyURL = ({ subdomain, propertyId, source })=>{
    return (0, _routing.buildFullLink)("residentProperty", {
        params: {
            propertyId
        },
        prefix: getPublicPortalPrefix(subdomain),
        queryParams: {
            src: source
        }
    });
};
const buildGuestCustomObjectURL = ({ subdomain, customMapId, geometryId, source })=>{
    return (0, _routing.buildFullLink)("residentCustomObject", {
        params: {
            customMapId,
            geometryId
        },
        prefix: getPublicPortalPrefix(subdomain),
        queryParams: {
            src: source
        }
    });
};
const buildGuestDocumentUploadDetailURL = ({ subdomain, documentUploadId })=>{
    return (0, _routing.buildFullLink)("guestDocumentUploadDetail", {
        params: {
            id: documentUploadId
        },
        prefix: getPublicPortalPrefix(subdomain)
    });
};
const buildGuestDocumentUploadFileURL = ({ subdomain, documentUploadId })=>{
    return (0, _routing.buildFullLink)("guestDocumentUploadFile", {
        params: {
            id: documentUploadId
        },
        prefix: getPublicPortalPrefix(subdomain)
    });
};
const buildGuestWorkflowURL = ({ subdomain, workflowId })=>{
    return (0, _routing.buildFullLink)("workflow", {
        params: {
            workflowId
        },
        prefix: getPublicPortalPrefix(subdomain)
    });
};
const isNearmapURL = (url)=>url.includes("api.nearmap.com");
const buildPropertyURL = (_0)=>{
    let { prefix, lat, lng } = _0, queryParams = _object_without_properties(_0, [
        "prefix",
        "lat",
        "lng"
    ]);
    return (0, _routing.buildFullLink)("map", {
        params: {},
        queryParams: _object_spread_props(_object_spread({}, queryParams), {
            lat: lat === null || lat === void 0 ? void 0 : lat.toString(),
            lng: lng === null || lng === void 0 ? void 0 : lng.toString()
        }),
        prefix
    });
};
const buildCustomMapGeometryURL = (_0)=>{
    let { prefix, customMapId, geometryId } = _0, queryParams = _object_without_properties(_0, [
        "prefix",
        "customMapId",
        "geometryId"
    ]);
    return (0, _routing.buildFullLink)("map", {
        params: {},
        queryParams: _object_spread_props(_object_spread({}, queryParams), {
            customMapId,
            geometryId
        }),
        prefix
    });
};
const extractSubdomains = ({ url, applicationDomain = _env.APPLICATION_DOMAIN })=>{
    var _ref;
    var _match_groups_subdomains, _match_groups;
    if (!url) {
        return null;
    }
    const parsedURL = new URL(url);
    const subdomainsRegex = new RegExp(`^(?<subdomains>.+)\.${applicationDomain}`);
    const match = parsedURL.host.match(subdomainsRegex);
    return (_ref = match === null || match === void 0 ? void 0 : (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : (_match_groups_subdomains = _match_groups.subdomains) === null || _match_groups_subdomains === void 0 ? void 0 : _match_groups_subdomains.split(".")) !== null && _ref !== void 0 ? _ref : null;
};
const extractFirstSubdomain = ({ url, applicationDomain = _env.APPLICATION_DOMAIN })=>{
    var _ref;
    if (!url) return null;
    const subdomains = extractSubdomains({
        url,
        applicationDomain
    });
    return (_ref = subdomains === null || subdomains === void 0 ? void 0 : subdomains[0]) !== null && _ref !== void 0 ? _ref : null;
};
const isRootSubdomain = (url, applicationDomain = _env.APPLICATION_DOMAIN)=>{
    const subdomain = extractFirstSubdomain({
        url,
        applicationDomain
    });
    return subdomain === _constants.INTERNAL_APP_SUBDOMAIN;
};
const buildPasswordResetRequestUrl = ({ requestId, requesterType, subdomain })=>{
    const prefix = requesterType === _constants.PASSWORD_RESET_REQUESTER_TYPE.PUBLIC_USER ? getPublicPortalPrefix(subdomain) : getAppPrefix();
    return (0, _routing.buildFullLink)("passwordResetRequest", {
        params: {
            requestId
        },
        prefix
    });
};
const buildPublicUserConfirmationUrl = ({ token, subdomain })=>{
    return (0, _routing.buildFullLink)("signupConfirmation", {
        prefix: getPublicPortalPrefix(subdomain),
        params: {},
        queryParams: {
            token
        }
    });
};
const buildFullPublicWebsiteURL = ({ subdomain, routeName, params = {}, queryParams = {} })=>{
    return (0, _routing.buildFullLink)(routeName, {
        prefix: getPublicPortalPrefix(subdomain),
        params,
        queryParams
    });
};

//# sourceMappingURL=data:application/json;base64,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